import { colors } from "@material-ui/core";

export const white = "#FFFFFF";
export const black = "#000000";
export const darkThemeFlag = true;
//https://material.io/resources/color/#!/?view.left=0&view.right=1&primary.color=00c6e2&secondary.color=f9ae07&primary.text.color=000000

export const primaryColor = "#5386cc";
export const secondaryColor = "#1A2033";
export const buttonHoverColor = "#3a5d8e";
export const warningColor = "#ECC34E";
export const successColor = "#13c880";
export const cardBackgroundColor = "#30363D";
export const cardBorderColor = "#5f5f60";
export const popupSelectedGrayColor = "#a1a1a1";
export const popupBorderColor = "#5f5f60";
export const buttonOutlineBorderColor = "#5f5f60";
export const searchInputBorderColor = "#5f5f60";
export const dropdownItemSelected = "#30363D";
export const cardLightBackgroundColor = "#484E53";
export const cardLightFooterTitleColor = "#79848D";

export const errorColor = "#ff5544";

export const tableHeaderColor = "#30363D";
export const tableAndCardBackgroundColor = "#30363D";
export const alternateBackground = "#252A30";
export const tableHover = "#192028";
export const tableRowBorderHover = "#192028";

export const backgroundDefaultColor = "#192028";
export const backgroundSignInSignUpColor = "#192028";
export const backgroundSecondaryColor = "#30363D";
export const backgroundTernaryColor = "#33363d";
export const selectBackgroundColor = "#192028";
export const borderColor = "#33363d";
export const iconColor = darkThemeFlag ? "#fafafa" : "#8C92A1";
export const switchBaseUnCheckColor = colors.grey[300];
export const inputLabels = "#99989c";

// light
export const primaryColorLight = "#04AED6";
export const successColorLight = "#76E5B9";
export const errorColorLight = "#E15142";
export const tableHeaderColorLight = "#F4F6F9";
export const backgroundDefaultColorLight = "#192028";
export const backgroundSignInSignUpColorLight = "#192028";
export const iconColorLight = "#8C92A1";
export const navHoverColorLight = "#30363D";
export const buttonHoverColorLight = "#027995";

export const lightPalette = {
  common: {
    black: "#000",
    white: "#fff",
  },
  type: "light",
  primary: {
    main: "#04AED6",
    contrastText: "#fff",
    light: "#36bede",
    dark: "#027995",
  },
  secondary: {
    main: "#1A2033",
    dark: "#fff",
    contrastText: "#fff",
    light: "#474c5b",
  },
  error: {
    main: "#E15142",
    light: "#e77367",
    dark: "#9d382e",
    contrastText: "#fff",
  },
  warning: {
    main: "#ECC34E",
    light: "#efcf71",
    dark: "#a58836",
    contrastText: "#000000de",
  },
  info: {
    light: "#64b5f6",
    main: "#2196f3",
    dark: "#1976d2",
    contrastText: "#fff",
  },
  success: {
    main: "#76E5B9",
    light: "#91eac7",
    dark: "#52a081",
    contrastText: "#000000de",
  },
  grey: {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: "#1A2033",
    secondary: "#676F86",
    disabled: "#00000061",
    hint: "#00000061",
  },
  divider: "#0000001f",
  background: {
    paper: "#fff",
    default: "#fafafa",
  },
  action: {
    active: "#0000008a",
    hover: "#0000000a",
    hoverOpacity: 0.04,
    selected: "#00000014",
    selectedOpacity: 0.08,
    disabled: "#00000042",
    disabledBackground: "#0000001f",
    disabledOpacity: 0.38,
    focus: "#0000001f",
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
};
export const darkPalette = {
  common: {
    black: "#000",
    white: "#fff",
  },
  type: "dark",
  primary: {
    main: "#5386cc",
    contrastText: "#fff",
    light: "#759ed6",
    dark: "#3a5d8e",
  },
  secondary: {
    main: "#1A2033",
    dark: "#30363D",
    contrastText: "#fff",
    light: "#474c5b",
  },
  error: {
    main: "#ff5544",
    light: "#ff7769",
    dark: "#ff5544",
    contrastText: "#fff",
  },
  warning: {
    main: "#ECC34E",
    light: "#efcf71",
    dark: "#ECC34E",
    contrastText: "#000000de",
  },
  info: {
    light: "#64b5f6",
    main: "#2196f3",
    dark: "#1976d2",
    contrastText: "#fff",
  },
  success: {
    main: "#13c880",
    light: "#42d399",
    dark: "#13c880",
    contrastText: "#000000de",
  },
  grey: {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
  text: {
    primary: "#ffffff",
    secondary: "#fafafa",
    disabled: "#00000061",
    hint: "#00000061",
    fail: "#eb6161",
    success: "#48db70",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: "#192028",
    default: "#192028",
  },
  action: {
    active: "#0000008a",
    hover: "#0000000a",
    hoverOpacity: 0.04,
    selected: "#00000014",
    selectedOpacity: 0.08,
    disabled: "#00000042",
    disabledBackground: "#0000001f",
    disabledOpacity: 0.38,
    focus: "#0000001f",
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
};
